module.exports = __webpack_public_path__ + "img/lesson6.263403dc.png";